import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyACDIYQ3s-RXLIO1wUugD7Y1MCHHQ9KVu0",
  authDomain: "identity-ai-5909a.firebaseapp.com",
  projectId: "identity-ai-5909a",
  storageBucket: "identity-ai-5909a.firebasestorage.app",
  messagingSenderId: "824583065220",
  appId: "1:824583065220:web:88cca44316c86b0785fcd1",
  measurementId: "G-BQRBQP1NSS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services you'll use
export const auth = getAuth(app);
export const db = getFirestore(app);
export const database = getDatabase(app);